import React from "react";
import ExtractionPrisma from "../../Components/extractionprisma.js";


function ExtractionprismaPage() {
  return (
    <div>
      <ExtractionPrisma/>
    </div>
  )
}

export default ExtractionprismaPage

